module.exports = __webpack_public_path__ + "img/queue-card.adf8a2fc.jpg";